import store from '@/store';
import { newEvent } from '@/shared/utils/notification-title';
import randomColor from '@/shared/utils/random-color';
import moment from 'moment';
import { SET_JOB_CHANNEL } from '@/store/mutation-types.js';
import { EventBus } from '@/event-bus.js';
import { normalizeChatIdentifier } from '@/shared/utils/helpers';

export default class NewChatEvent {
  constructor(body) {
    const job = body;

    job.color = randomColor();
    job.channel = 'chat';
    job.messages = [];
    job.history = [];
    job.transferCount = job.transferCount || 0;
    job.disabled = false;
    job.disabled = job.closedWithoutQualify || false;
    job.time = 0;
    job.notifications = 0;
    job.clientStatus = 'online';
    job.typing = false;
    job.tab = {
      active: 0,
      tab: 'message',
    };
    job.contactIdentifier = normalizeChatIdentifier(job.contactIdentifier);
    job.paramsHistoryMessages = {
      page: 1,
      initialDate: moment().format('YYYY-MM-DD HH:mm:ss'),
    };

    job.observation = job.observation || '';

    if (job.observation) {
      store.dispatch('observation/newObservation', {
        observation: job.observation,
        protocol: job.protocol,
      });
    }

    EventBus.$emit('close-toggle-infobars');
    store.dispatch('jobs/newChat', job);
    store.commit(`jobs/${SET_JOB_CHANNEL}`, 'chat');
    newEvent();
  }
}
